// extracted by mini-css-extract-plugin
export default {"facetMenu":"Up-z","fixed":"Vp-z","nonLayerdFacets":"Wp-z","productCount":"Xp-z","facetBack":"Yp-z","arrow":"Zp-z","facetClose":"_p-z"};